// Validation errors mapper for custom input.
export const ErrorMessages: { [key: string]: string } = {
  required: 'This field is required',
  email: 'Invalid email address',
  minlength: 'Length too short',
};
